<template>
  <div class="clearfix row no-margin">
    <div class="col-md-12 fixed-section-one mb-4">
      <div class="clearfix approval-container row">
          <div class="col-4 approve-level-label">
              <div class="approve-level-title px-0 text-left">
                  PF Settlement Consent Settings
              </div>
              <div class="approve-level-description">
                  The PF Settlement Consent Settings defines Consent for which Members may be leaving the Provident Fund and seeking settlement, and the conditions in regards to their Employment Service Period and/ or PF Membership Period lengths upon which their eligible Settlement amounts (in percentages of balance) are calculated in alignment to PF Trust Deed.
              </div>
          </div>
          <div class="col-8 approve-level-content">
            <div class="clearfix">
              
                
              
              <div class="row mx-1 no-margin align-items-center py-3" >
                <div class="col-md-10 px-0 salary-heads">Require former Member's Consent</div>
                <div class="col-md-2 text-right px-0">
                  <toggle-button v-model="fdata.frm_mem_cons" key="company_pf_multiple_loan"  :sync="true"  :color="{checked: '#38c172', unchecked: '#e3342f', disabled: '#CCCCCC'}" v-validate="{ required: false }" />
                </div>
              </div>
              <div class="row mx-1 no-margin align-items-center py-3">
                <div class="col-md-10 px-0 salary-heads" v-if="fdata.frm_mem_cons">Set Allowed Days for Consent</div>
                <div class="col-md-2 text-right px-0" v-if="fdata.frm_mem_cons">
                  <toggle-button v-model="fdata.set_cons_alw_day" key="company_pf_multiple_loan"  :color="{checked: '#38c172', unchecked: '#e3342f', disabled: '#CCCCCC'}" v-validate="{ required: false }" />
                </div>
              </div>
              <div class="row mx-1 no-margin align-items-center py-3" v-if="fdata.set_cons_alw_day && fdata.frm_mem_cons">
                
                <div class="col-md-8 px-0 salary-heads" ></div>
                <div class="col-md-4 text-right px-0 d-flex align-items-center" > 
                  <b-input-group append="Day(s)" v-if="fdata.set_cons_alw_day == 1" >		
                    <b-form-input v-model="fdata.cons_alw_day" type="number" :min="1" ></b-form-input>
                  </b-input-group>
                </div>
                 
              </div>

              <div class="row mx-1 no-margin align-items-center py-3" >                    

                <div class="col-md-10 px-0 salary-heads" v-if="fdata.frm_mem_cons">Allow Management Portal Consent</div>
                <div class="col-md-2 text-right px-0" v-if="fdata.frm_mem_cons">
                  <toggle-button v-model="fdata.alw_mng_cons" key="company_pf_multiple_loan"  :color="{checked: '#38c172', unchecked: '#e3342f', disabled: '#CCCCCC'}" v-validate="{ required: false }" />
                </div>

              </div>
              
            <div class=" m-4">   
              <b-button type="button" variant="primary" class="custom-wizard-btn" @click="saveData">Save</b-button>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
    export default{
        
        data(){
            return {
                
               fdata:{}, 
              
              
              url : this.$api_url+'/pf/settl-consent-settings',
              
              

            }
        },
        methods:{
            
            
          getData: function()
          {            
              if(!this.checkNet()) return false;
              let currentObj = this;
              axios.get(this.url).then(function(response){
                                  
                //this.fdata = response.data;  

                this.fdata = {
                alw_mng_cons: response.data.alw_mng_cons === '1',
                frm_mem_cons: response.data.frm_mem_cons === '1',
                set_cons_alw_day: response.data.set_cons_alw_day === '1',
                cons_alw_day: parseInt(response.data.cons_alw_day),
                // Map other fields similarly
               };
                                 
            
              }.bind(this)).catch(function (error){ currentObj.serverError(error);});
          },
          
          saveData: function()
          {            
              if(!this.checkNet()) return false;
              
              let currentObj = this;
              const payload = {
                alw_mng_cons: currentObj.fdata.alw_mng_cons ? 1 : 0,
                frm_mem_cons: currentObj.fdata.frm_mem_cons ? 1 : 0,
                set_cons_alw_day: currentObj.fdata.set_cons_alw_day ? 1 : 0,
                cons_alw_day: parseInt(currentObj.fdata.cons_alw_day),
              };
              console.log('payload');
              console.log(payload);
              axios.post(this.url, {fdata: payload})
                    .then(function (response) 
                    {
                      
                      this.$bvToast.toast('Saved!', {
                              title: `Success`,
                              variant: 'success',
                              solid: true
                          });
                      
                        
                    }.bind(this))
                    .catch(function (error) 
                    {                          
                      this.showoverlay = false;                        
                      currentObj.serverError(error);
                    });
          },
           
        },
        created: function(){
          
          this.getData();
          
      },
    }
</script>
